import { fetchOverviewTablesForTemplateIds } from "src/requests/table/requestCreators";
import flowioast from "src/utils/flowioast";
import { EwaThunk } from "../types";
import {
  setOverviewTablesAction,
  setOverviewTablesLoading,
} from "./actionCreators";
import { getIsOverviewTablesLoading } from "./selectors";
import { transformToOverviewTablesByTemplateId } from "./utils";

// eslint-disable-next-line import/prefer-default-export
export const fetchOverviewTablesThunk =
  (templateIds: number[]): EwaThunk =>
  async (dispatch, getState): Promise<void> => {
    const state = getState();

    const isLoading = getIsOverviewTablesLoading(state);

    if (isLoading) return;

    dispatch(setOverviewTablesLoading({ isLoading: true }));

    try {
      const { data } = await fetchOverviewTablesForTemplateIds(templateIds);
      const tablesByTemplateId = transformToOverviewTablesByTemplateId(data);
      dispatch(setOverviewTablesAction({ tablesByTemplateId }));
    } catch (e) {
      flowioast.error.fromIntlId("table.overview.error", e);
    } finally {
      dispatch(setOverviewTablesLoading({ isLoading: false }));
    }
  };
